import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, Flex, Img, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text, Button } from "@chakra-ui/react";
import { MdMail, MdPhone } from 'react-icons/md';
import { RiWhatsappFill } from "react-icons/ri";
import { FaCartPlus } from "react-icons/fa";
import { addToCart } from '../actions/cartActions';

const ProductDetailModal = ({ product, onClose, visible, store }) => {
    const { name = "", price = "", description = "", images = [], stock = 10 } = product;
    const dispatch = useDispatch();

    const handleAddToCart = () => {
        dispatch(addToCart(product._id, 1));
        onClose();
    };

    return (
        <>
            <Modal isOpen={visible} onClose={onClose} size='md'>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Información</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex flexDir='column' alignItems='center'>
                            <Img 
                                w='80%'
                                src={images[0]}
                                alt={name}
                                minH="100%"
                                maxH="200px"
                                objectFit={"contain"}
                            />
                            <Flex 
                                flexDir={"row"}
                                justifyContent={"space-between"}
                                w='100%'
                                my='20px'
                            >
                                <Flex w='100%' flexDir={"column"}>
                                    <Flex alignItems='center'>
                                        <Text fontSize="1.2em" fontWeight="500" mr='.5em'>{name}</Text>
                                        <Text fontSize="1em" fontWeight="200">${price}</Text>
                                    </Flex>
                                    <Text fontSize="1em" fontWeight="200">{description}</Text>
                                    <Text fontSize="1em" fontWeight="200">{stock} {stock === 1 ? "disponible" : "disponibles"}</Text>
                                </Flex>
                                <Flex>
                                    <Button 
                                        colorScheme='teal' 
                                        onClick={handleAddToCart}
                                        size="sm"
                                        fontSize={".8em"}
                                        aria-label="Agregar al carrito"
                                        title="Agregar al carrito"
                                        tabIndex={0}
                                    >
                                        <Text>Agregar al carrito</Text>
                                        <FaCartPlus style={{ marginLeft: "5px" }} />
                                    </Button>
                                </Flex>
                            </Flex>
                            <Flex flexDir='column' mb='20px' mt='20px'>
                                <Text>Pedir información</Text>
                                <Flex w='100%' justifyContent='space-evenly' mt='3px'>
                                    <Link href={`mailto:${store.contactInfo.email}`}>
                                        <MdMail size='1.2em' />
                                    </Link>
                                    <Link href={`https://api.whatsapp.com/send?phone=${store.contactInfo.phone}&text=%C2%A1Hola%20,%20deseo%20informaci%C3%B3n%20sobre%20el%20art%C3%ADculo:%20${name}!`} target='_blank'>
                                        <RiWhatsappFill size='1.2em' />
                                    </Link>
                                    <Link href={`tel:${store.contactInfo.phone}`}>
                                        <MdPhone size='1.2em' />
                                    </Link>
                                </Flex>
                            </Flex>
                        </Flex>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};

export default ProductDetailModal;